import {
  getOperationCoordinator,
  STEP_STATUS,
} from "../../../operationFeedback";

/**
 * Client-side CASE_*_FORBIDDEN: dialog-owned OF, not a silent no-op or toast.
 * Matches the API problem shape (kind/forbidden, recovery/contact_admin).
 */
export function presentCaseAccessForbidden({
  code,
  message,
  title,
  saveLabel,
}) {
  const coordinator = getOperationCoordinator();
  const op = coordinator.start({
    operationKey: "case_access",
    title: title || message,
    presentationOwner: "dialog",
    steps: [
      {
        key: "save",
        label: saveLabel || title || message,
        status: STEP_STATUS.FAILED,
        detail: message,
      },
    ],
  });
  coordinator.complete(op.clientOperationId, {
    summary: message,
    outcome: "not_applied",
    kind: "forbidden",
    code,
    recovery: "contact_admin",
    error: {
      code,
      kind: "forbidden",
      safeMessage: message,
    },
  });
  return op;
}
